import { ceil } from 'lodash'
import { algo } from 'crypto-js'
// e.g. firebase Id 08ZBMrjX1eH665XM5a4M
// 20 chars, mixed from lower, upper alpha and numeric
const lowerAlpha = 'abcdefghijklmnopqrstuvwxyz'
const upperAlpha = lowerAlpha.toUpperCase()
const numeric = '1234567890'
const chars = lowerAlpha+upperAlpha+numeric

const stripAlpha = (str: string) => {
  return str
    .replace(new RegExp('a', 'g'), '')
    .replace(new RegExp('b', 'g'), '')
    .replace(new RegExp('c', 'g'), '')
    .replace(new RegExp('d', 'g'), '')
    .replace(new RegExp('e', 'g'), '')
    .replace(new RegExp('f', 'g'), '')
}

const getIdFromNumeric = (str: string) => {
  const strLen = str.length
  let nChars: number
  if(strLen % 2 === 0) {
    nChars = strLen/2
  } else {
    nChars = (strLen-1)/2
  }
  const firebaseIdIndices: number[] = []
  let i: number
  for(i=0; i<nChars; i++) {
    firebaseIdIndices.push( ceil(chars.length*parseFloat(str.substr(2*i, 2))/99) )
  }
  const firebaseId = firebaseIdIndices.map(idx=>chars.charAt(idx)).join("").substr(-20)
  return firebaseId
}

export const getDeterministicFirebaseId = (inputStr: string) => {
  const salt = ''
  const hashF = algo.HMAC.create(algo.SHA256, salt); /** Hashing algorithm sha512 */
  const hashR = algo.HMAC.create(algo.SHA256, salt); /** Hashing algorithm sha512 */
  hashF.update(inputStr);
  hashR.update(inputStr.split("").reverse().join(""));
  const hashNumericForward = stripAlpha('' + hashF.finalize())
  const hashNumericReverse = stripAlpha('' + hashR.finalize())
  const hashNumeric = hashNumericForward+hashNumericReverse
  return getIdFromNumeric(hashNumeric)
}
